import { Button, Modal } from "antd";
import React from "react";

function DeleteModal({ isModalOpen, handleCancel, handleDelete }) {
  return (
    <div>
      <Modal
        width={440}
        height={177}
        title={
          <div
            style={{
              fontSize: "18px",
              fontWeight: 500,
              textAlign: "left",
            }}
          >
            Delete the File
          </div>
        }
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <div
            style={{
              display: "flex",
              marginLeft: "100px",
              gap: "20px",
            }}
          >
            <Button
              key="cancel"
              onClick={handleCancel}
              style={{
                width: "130px",
                height: "34px",
                padding: "6.5px 38.5px 6.5px 39.5px",
                borderRadius: "8px",
                border: "1px solid #1F243B",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 400,
                }}
              >
                Cancel
              </div>
            </Button>

            <Button
              key="delete"
              onClick={handleDelete}
              style={{
                width: "130px",
                height: "34px",
                padding: "6.5px 40.5px 6.5px 41.5px",
                borderRadius: "8px",
                border: "1px solid #C2FAE5",
                backgroundColor: "#C2FAE5",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 400,
                }}
              >
                Delete
              </div>
            </Button>
          </div>,
        ]}
        centered
        closable={false}
      >
        <p
          style={{
            fontSize: "16px",
            fontWeight: 400,
            textAlign: "left",
            color: "#636980",
          }}
        >
          Are you sure you want to delete this file?
        </p>
        <br />
      </Modal>
    </div>
  );
}

export default DeleteModal;
